import { getData, postJsonData } from "../baseApi";
import legacy from "../../utils/legacy";

const ENDPOINTS = {
  REPORT_DATA: "/detail/report_data/",
  REQUEST_REPORT: "/detail/request_report/",
  CHECK_STATUS: "/detail/check_report_status/",
  SALE_REPORT_IMAGES: "/detail/sale_report_images/",
};

export const fetchReportData = (suid) => {
  return getData(ENDPOINTS.REPORT_DATA, { suid });
};

export const requestReport = (suid, config, data) => {
  return postJsonData(
    `${ENDPOINTS.REQUEST_REPORT}?suid=${encodeURIComponent(suid)}&preset=sale_v2`,
    { config, data }
  );
};

export const checkReportStatus = (suid, reportUuid) => {
  return getData(ENDPOINTS.CHECK_STATUS, {
    preset: "sale_v2",
    key: suid,
    report_uuid: reportUuid,
  });
};

export const fetchSaleReportImages = (suid) => {
  return getData(ENDPOINTS.SALE_REPORT_IMAGES, { suid });
};

/**
 * 이미지 파일을 레거시 discoImageUploader(func=sale)로 업로드.
 * 반환: save_name (파일키, 예: "abc123def456.jpg")
 */
export const uploadReportImage = (file) => {
  return new Promise((resolve, reject) => {
    legacy.discoImageUploader('sale', [file], (state, items) => {
      if (state && items && items.length > 0 && items[0].state) {
        resolve(items[0].save_name);
      } else {
        reject(new Error('이미지 업로드에 실패했습니다.'));
      }
    });
  });
};
